import { env } from "@web/lib/env";
import axios, { type AxiosRequestConfig } from "axios";

export const api = axios.create({
  baseURL: env.VITE_APP_API_HOST,
  headers: {},
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const raw = localStorage.getItem("language");
  let language = "pt";
  if (raw) {
    try {
      language = JSON.parse(raw).value ?? "pt";
    } catch {
      language = "pt";
    }
  }
  config.headers["Accept-Language"] = language;
  return config;
});

export const apiInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const source = axios.CancelToken.source();

  const promise = api({
    ...config,
    ...options,
    cancelToken: source.token,
  })
    .then((response) => response.data)
    .catch((error) => {
      return Promise.reject(error.response);
    });

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  promise.cancel = () => {
    source.cancel("Query was cancelled");
  };

  return promise;
};

if (env.VITE_ENABLE_API_DELAY) {
  api.interceptors.request.use(async (config) => {
    await new Promise((resolve) =>
      setTimeout(resolve, Math.round(Math.random() * 4000)),
    );

    return config;
  });
}
